import { CustomAnswer } from "../types/customQuestion";

import { serializeAnswer } from "./customAnswer";

import { AnswerInput } from "@/types/trpc";

export const serializeParticipantAnswers = (answers: CustomAnswer[], rateId: string): AnswerInput[] => {
  return answers?.map((answer) => ({ ...serializeAnswer(answer), rateId }));
};
